import jss from 'jss';

const styles = {
  childContainer: {
    padding: '5px 0',
    width: '100%'
  },
  actionsContainer: {
    padding: '15px 0',
    borderTop: '1px solid rgba(240, 240, 240)',
    width: '100%',
    '& > *': {
      marginRight: 5
    }
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();


// WEBPACK FOOTER //
// ./src/views/customer/styles/modify.js